import React from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'
import { styled } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery'
import { Container, TitleProduct, Section, ContainerTitle, DesktopProductsGrid } from './styles'
import 'swiper/css'
import 'swiper/css/pagination'
import "swiper/css/navigation";
import { Pagination, Navigation } from 'swiper'
import PropTypes from 'prop-types'
import CardProduct from "../CardProduct";
import { trackSelectItemMarketplace, trackAddToWishlistMarketplace } from "../../utils/gtm";


const SwiperStyle = styled(Swiper)(({ theme }) => ({
  "& .swiper-pagination-bullet-active": {
    display: "block",
  },
  "& .swiper-pointer-events": {
    display: "block",
  },
  "& .swiper-button-prev,& .swiper-button-next,& .swiper-rtl .swiper-button-next,& .swiper-rtl .swiper-button-prev":
  {
    display: "block",
  },
}));
export default function FeaturedProduct({ sectionsData }) {
  const isDesktop = useMediaQuery('(min-width:1024px)')

  const renderProductCard = (product, i, sectionData) => {
    const { id, label, price } = product;
    const priceFormatted = {
      BRL: {
        offer: price?.BRL?.offer ?? 0,
        price: price?.BRL?.offer !== price?.BRL?.price ? price?.BRL?.price : null
      },
      points: {
        offer: Math.round(price?.points?.offer) ?? 0,
        price: price?.points?.offer !== price?.points?.points ? Math.round(price?.points?.points) : null
      },
    };
    return (
      <CardProduct
        id={id}
        label={label}
        image={Array.isArray(product?.images) ? product?.images[0]?.small : product?.images?.small}
        price={priceFormatted}
        campaign=""
        wishlist={product.wishlist}
        onProductClick={() => trackSelectItemMarketplace({
          itemListName: sectionData.label,
          itemId: product.id || "",
          itemName: product.label || "",
          discount: product.price?.BRL?.offer !== product.price?.BRL?.price
            ? Math.max(0, parseFloat(product.price?.BRL?.price || 0) - parseFloat(product.price?.BRL?.offer || 0))
            : 0,
          index: i,
          itemBrand: product.brand?.name || "",
          itemCategory: "",
          price: parseFloat(product.price?.BRL?.offer || 0),
          quantity: 1,
        })}
        onAddToWishlist={() => trackAddToWishlistMarketplace({
          itemListName: sectionData.label,
          itemId: product.id || "",
          itemName: product.label || "",
          discount: product.price?.BRL?.offer !== product.price?.BRL?.price
            ? Math.max(0, parseFloat(product.price?.BRL?.price || 0) - parseFloat(product.price?.BRL?.offer || 0))
            : 0,
          index: i,
          itemBrand: product.brand?.name || "",
          itemCategory: "",
          price: parseFloat(product.price?.BRL?.offer || 0),
          quantity: 1,
        })}
      />
    );
  };

  return (
    <Container>
      {sectionsData?.sort((a, b) => a.ordering - b.ordering).map((sectionData, index) => {
        const { items, label } = sectionData
        return (
          <Container key={index}>
            <ContainerTitle>
              <TitleProduct className='font-wl-400' >{label}</TitleProduct>
            </ContainerTitle>
            <Section>
              {isDesktop ? (
                <DesktopProductsGrid>
                  {items?.map((product, i) => (
                    <div className="grid-cell" key={index + '-' + i + '-' + product.id}>
                      {renderProductCard(product, i, sectionData)}
                    </div>
                  ))}
                </DesktopProductsGrid>
              ) : (
                <SwiperStyle
                  slidesPerView={2}
                  breakpoints={{
                    568: { slidesPerView: 4 },
                  }}
                  spaceBetween={32}
                  pagination={{
                    clickable: true,
                  }}
                  navigation={{
                    nextEl: '.swiper-button-next-' + index,
                    prevEl: '.swiper-button-prev-' + index,
                  }}
                  modules={[Pagination, Navigation]}
                  className="mySwiper"
                >
                  {items?.map((product, i) => (
                    <SwiperSlide key={index + '-' + i + '-' + product.id}>
                      {renderProductCard(product, i, sectionData)}
                    </SwiperSlide>
                  ))}
                </SwiperStyle>
              )}
            </Section>
          </Container>
        );
      })}
    </Container>
  )
}

FeaturedProduct.propTypes = {
  sectionsData: PropTypes.array
}
